import React, { useRef, useState } from 'react';
import Icon from '@ant-design/icons';
import styled from '@emotion/styled';
import { Space } from 'antd';
import Modal from 'antd/lib/modal/Modal';
import Checkbox from 'antd/es/checkbox/Checkbox';
import Button from 'antd/es/button';
// import { useOpenReturnStatus } from 'hooks/business/openReturnStatus';
// import chatttSDK from 'services/chattt';
import { useTranslate } from '@tolgee/react';
import { goPlatform } from 'views/Refund/utils/store';
import { ReactComponent as shopeeIcon } from './assets/shopee.svg';
import { ReactComponent as lazadaIcon } from './assets/lazada.svg';
import { useTransAppProductName } from 'hooks/useTrans';
import { goPlatformServiceNoRemindCache } from 'services/cache';

const Box = styled.div`
  position: absolute;
  width: 18px;
  height: 18px;
  right: 12px;
  top: 8px;
  cursor: pointer;
  filter: grayscale(100%);
  &:hover {
    filter: none;
  }
`;
const ModalFooter = styled.div`
  display: flex;
  justify-content: space-between;
`;

export interface NavToPlatformProps {
  conversation: Conversation.Conversation;
}

const NavToPlatform = (props: NavToPlatformProps) => {
  const { conversation } = props;
  const { channel } = conversation;
  const [visible, setVisible] = useState(false);
  // const returnOpen = useOpenReturnStatus();
  const noRemind = useRef(!!goPlatformServiceNoRemindCache.get());
  const { t } = useTranslate();
  const appProductNameT = useTransAppProductName();

  return (
    <Box>
      {channel === 'SHOPEE' && (
        <Icon
          component={shopeeIcon}
          onClick={() => {
            goPlatform(conversation.storeId);
          }}
        />
      )}
      {channel === 'LAZADA' && (
        <Icon
          component={lazadaIcon}
          onClick={() => {
            goPlatform(conversation.storeId);
          }}
        />
      )}
      <Modal
        title={t('scene.chatWorkspace.orderTab.dialog.leaveSellerCenter.title')}
        visible={visible && !goPlatformServiceNoRemindCache.get()}
        onCancel={() => setVisible(false)}
        footer={
          <ModalFooter>
            <Checkbox
              onChange={(e) => {
                noRemind.current = e.target.checked;
              }}
            >
              {t('scene.chatWorkspace.orderTab.dialog.leaveSellerCenter.action.doNotRemindAgain')}
            </Checkbox>
            <Space>
              <Button onClick={() => setVisible(false)}>{t('common.action.cancel')}</Button>
              <Button
                type="primary"
                onClick={() => {
                  goPlatform(conversation.storeId);
                  if (noRemind.current) {
                    goPlatformServiceNoRemindCache.set('1');
                  } else {
                    goPlatformServiceNoRemindCache.remove();
                  }
                  setVisible(false);
                }}
              >
                {t('common.action.confirm')}
              </Button>
            </Space>
          </ModalFooter>
        }
        width={380}
      >
        {appProductNameT('scene.chatWorkspace.orderTab.leaveSellerCenterDialog.description')}
      </Modal>
    </Box>
  );
};
export default NavToPlatform;
